module.exports = __webpack_public_path__ + "static/img/img_cartao.0ce803fd.png";